import { serverOverride } from './net/serverOverride';

/** `?server=` from the page's address, where this build and page may take one (see serverOverride). */
const overrideUrl =
  typeof location === 'undefined'
    ? undefined
    : serverOverride(location.search, location.hostname, import.meta.env.DEV);

/** Build-time configuration. Values come from Vite env vars set by the deploy workflow. */
export const config = {
  version: __APP_VERSION__,
  commit: __GIT_SHA__,
  /** Empty string means "no server configured" (the game still works offline vs the AI). */
  serverUrl: (overrideUrl ?? import.meta.env.VITE_SERVER_URL ?? defaultServerUrl()).replace(
    /\/$/,
    '',
  ),
  /** The server came from the page's `?server=`, not the build: the sign-in form says so. */
  serverOverridden: overrideUrl !== undefined,
  appInsightsConnectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ?? '',
} as const;

function defaultServerUrl(): string {
  return import.meta.env.DEV ? 'http://localhost:8080' : '';
}

/** `https://host` → `wss://host/ws` (and `http` → `ws` for local development). */
export function webSocketUrl(serverUrl: string): string {
  return `${serverUrl.replace(/^http/, 'ws')}/ws`;
}
